module.exports = __webpack_public_path__ + "img/IMG_1842.99990b50.jpg";